import React from "react";
import { Tabs, TabsList, TabsTrigger } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";
import { useDisabledJobTypes } from "~/shared/hooks/useDisabledJobTypes";

export type CategoryKey = "all" | "CO" | "MSW" | "TIPPER" | "DISINFECTION" | "LIQUID";

export const CATEGORIES: CategoryKey[] = ["all", "CO", "MSW", "TIPPER", "DISINFECTION", "LIQUID"];

interface Props {
  value: CategoryKey;
  onChange: (category: CategoryKey) => void;
}

export const CategoryChips: React.FC<Props> = ({ value, onChange }) => {
  const t = useT();
  // A category whose job types the organization all turned off has no chip.
  const disabledCategories = useDisabledJobTypes().categories;

  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as CategoryKey)} className="shrink-0">
      <TabsList className="max-md:w-full max-md:overflow-x-auto max-md:justify-start">
        {CATEGORIES.filter((key) => !disabledCategories.has(`CATEGORY_${key}`)).map((key) => (
          <TabsTrigger key={key} value={key} className="shrink-0">
            {key === "all"
              ? t(Namespace.Analytics, "categories.all")
              : t(Namespace.Enum, `CATEGORY_${key}`)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
